export var IMPORT_TYPES_CONFIG = [
    {
        key: "thema",
        apiValue: "THEMA",
        translationKey: "ui-br-agency.import.type.thema",
        importFlow: "thema",
    },
    {
        key: "legal-persons",
        apiValue: "LEGAL_PERSONS",
        translationKey: "ui-br-agency.import.type.legal-persons",
        importFlow: "authority",
    },
    {
        key: "natural-persons",
        apiValue: "NATURAL_PERSONS",
        translationKey: "ui-br-agency.import.type.natural-persons",
        importFlow: "authority",
    },
    {
        key: "titles",
        apiValue: "TITLES",
        translationKey: "ui-br-agency.import.type.titles",
        importFlow: "titleFile",
    },
];
export var getImportTypeByKey = function (key) {
    return IMPORT_TYPES_CONFIG.find(function (type) { return type.key === key; });
};
